'use client';

import React from 'react';
import ServiceCard from './ServiceCard';
import ROICalculator from './ROICalculator';
import ServiceComparison from './ServiceComparison';
import TechnologyStack from './TechnologyStack';
import TestimonialCarousel from './TestimonialCarousel';
import CTASection from './CTASection';
import service1 from '../../../../public/assets/images/service/service1.png'
import service2 from '../../../../public/assets/images/service/service2.jpeg'
import service3 from '../../../../public/assets/images/service/service3.jpeg'
import service4 from '../../../../public/assets/images/service/service4.jpeg'
import service5 from '../../../../public/assets/images/service/service5.png'
import service6 from '../../../../public/assets/images/service/service5.png'

interface Service {
  title: string;
  description: string;
  icon: string;
  image: string;
  imageAlt: string;
  features: string[];
  caseStudyCount: number;
  avgROI: string;
  href: string;
}

const ServicesInteractive = () => {
  const services: Service[] = [
  {
    title: 'Cloud Infrastructure',
    description: 'Scalable, secure cloud solutions that grow with your business. From migration to optimization, we handle every aspect of your cloud journey.',
    icon: 'CloudIcon',
    image:service1.src,
    imageAlt: 'Modern data center with rows of blue-lit server racks in clean white facility',
    features: [
    'AWS, Azure, and Google Cloud expertise',
    'Zero-downtime migration strategies',
    'Cost optimization and monitoring',
    'Auto-scaling and load balancing'],

    caseStudyCount: 47,
    avgROI: '285%',
    href: '/services/cloud-infrastructure'
  },
  {
    title: 'Custom Software Development',
    description: 'Tailored applications built with modern technologies to solve your unique business challenges and drive operational efficiency.',
    icon: 'CodeBracketIcon',
    image:service2.src,
    imageAlt: 'Developer hands typing code on laptop with multiple monitors showing colorful programming interfaces',
    features: [
    'Full-stack web and mobile development',
    'API design and microservices architecture',
    'Legacy system modernization',
    'Agile development methodology'],

    caseStudyCount: 63,
    avgROI: '320%',
    href: '/services/software-development'
  },
  {
    title: 'DevOps & Automation',
    description: 'Streamline your development pipeline with CI/CD automation, infrastructure as code, and continuous monitoring solutions.',
    icon: 'CommandLineIcon',
    image:service3.src,
    imageAlt: 'Abstract digital network visualization with glowing blue nodes and connection lines on dark background',
    features: [
    'CI/CD pipeline implementation',
    'Container orchestration with Kubernetes',
    'Infrastructure automation with Terraform',
    'Performance monitoring and alerting'],

    caseStudyCount: 38,
    avgROI: '245%',
    href: '/services/devops'
  },
  {
    title: 'Cybersecurity Solutions',
    description: 'Comprehensive security assessments, threat detection, and compliance management to protect your digital assets.',
    icon: 'ShieldCheckIcon',
    image:service4.src,
    imageAlt: 'Digital padlock icon glowing blue on dark circuit board background representing cybersecurity',
    features: [
    'Penetration testing and vulnerability assessments',
    'SOC 2, HIPAA, and GDPR compliance',
    'Security incident response planning',
    'Employee security training programs'],

    caseStudyCount: 52,
    avgROI: '410%',
    href: '/services/cybersecurity'
  },
  {
    title: 'Data Analytics & BI',
    description: 'Transform raw data into actionable insights with custom dashboards, predictive analytics, and machine learning solutions.',
    icon: 'ChartBarIcon',
    image:service5.src,
    imageAlt: 'Business analytics dashboard on laptop screen showing colorful graphs and data visualizations',
    features: [
    'Custom dashboard development',
    'Predictive analytics and ML models',
    'Data warehouse design and ETL',
    'Real-time reporting and alerts'],

    caseStudyCount: 41,
    avgROI: '365%',
    href: '/services/data-analytics'
  },
  {
    title: 'IT Consulting & Strategy',
    description: 'Strategic technology planning and digital transformation roadmaps aligned with your business objectives.',
    icon: 'LightBulbIcon',
    image:service6.src,
    imageAlt: 'Business team collaborating around table with laptops and documents in bright modern office',
    features: [
    'Technology roadmap development',
    'Digital transformation planning',
    'Vendor selection and management',
    'IT governance and best practices'],

    caseStudyCount: 29,
    avgROI: '295%',
    href: '/services/consulting'
  }];


  return (
    <div data-component-id="src/app/services-overview/components/ServicesInteractive.tsx:130:4" data-component-path="src/app/services-overview/components/ServicesInteractive.tsx" data-component-line="130" data-component-end-line="147" data-component-file="ServicesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-16%22%7D" className="space-y-16">
      <div data-component-id="src/app/services-overview/components/ServicesInteractive.tsx:131:6" data-component-path="src/app/services-overview/components/ServicesInteractive.tsx" data-component-line="131" data-component-end-line="135" data-component-file="ServicesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-8%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((service, index) =>
        <ServiceCard data-component-id="src/app/services-overview/components/ServicesInteractive.tsx:133:8" data-component-path="src/app/services-overview/components/ServicesInteractive.tsx" data-component-line="133" data-component-end-line="133" data-component-file="ServicesInteractive.tsx" data-component-name="ServiceCard" data-component-content="%7B%22elementName%22%3A%22ServiceCard%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" key={index} {...service} />
        )}
      </div>

      <div data-component-id="src/app/services-overview/components/ServicesInteractive.tsx:137:6" data-component-path="src/app/services-overview/components/ServicesInteractive.tsx" data-component-line="137" data-component-end-line="140" data-component-file="ServicesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-2%20gap-8%22%7D" className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <ROICalculator data-component-id="src/app/services-overview/components/ServicesInteractive.tsx:138:8" data-component-path="src/app/services-overview/components/ServicesInteractive.tsx" data-component-line="138" data-component-end-line="138" data-component-file="ServicesInteractive.tsx" data-component-name="ROICalculator" data-component-content="%7B%22elementName%22%3A%22ROICalculator%22%7D" />
        <TestimonialCarousel data-component-id="src/app/services-overview/components/ServicesInteractive.tsx:139:8" data-component-path="src/app/services-overview/components/ServicesInteractive.tsx" data-component-line="139" data-component-end-line="139" data-component-file="ServicesInteractive.tsx" data-component-name="TestimonialCarousel" data-component-content="%7B%22elementName%22%3A%22TestimonialCarousel%22%7D" />
      </div>

      <ServiceComparison data-component-id="src/app/services-overview/components/ServicesInteractive.tsx:142:6" data-component-path="src/app/services-overview/components/ServicesInteractive.tsx" data-component-line="142" data-component-end-line="142" data-component-file="ServicesInteractive.tsx" data-component-name="ServiceComparison" data-component-content="%7B%22elementName%22%3A%22ServiceComparison%22%7D" />

      <TechnologyStack data-component-id="src/app/services-overview/components/ServicesInteractive.tsx:144:6" data-component-path="src/app/services-overview/components/ServicesInteractive.tsx" data-component-line="144" data-component-end-line="144" data-component-file="ServicesInteractive.tsx" data-component-name="TechnologyStack" data-component-content="%7B%22elementName%22%3A%22TechnologyStack%22%7D" />

      <CTASection data-component-id="src/app/services-overview/components/ServicesInteractive.tsx:146:6" data-component-path="src/app/services-overview/components/ServicesInteractive.tsx" data-component-line="146" data-component-end-line="146" data-component-file="ServicesInteractive.tsx" data-component-name="CTASection" data-component-content="%7B%22elementName%22%3A%22CTASection%22%7D" />
    </div>);

};

export default ServicesInteractive;